import {Directive, HostListener, Input} from "@angular/core";
import {NgForm} from "@angular/forms";

@Directive({selector: '[scrollToFirstInvalid]'})
export class ScrollToFirstInvalidDirective {
  @Input() selectedForm: NgForm;

  constructor() {
  }

  @HostListener('submit', ['$event'])
  onSubmit(event) {
    if (!this.selectedForm.valid) {
      let target;
      for (var i in this.selectedForm.controls) {
        if (!this.selectedForm.controls[i].valid) {
          target = i;
          break;
        }
      }
      console.log(target)
      console.log($('[formControlName="'+target+'"]:first').offset())
      if (target) {
        $('html,body').animate({scrollTop: ($('[formControlName="'+target+'"]').offset().top - 120 )}, 'slow');
      }
    }
  }
}


// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/directives/scroll-to-first-invalid.directive.ts